import { useEffect } from "react";
import { ROUTES } from "../../../routes";

const AccountOpeningPrivacyNotice = () => {
  useEffect(() => {
    window.location.replace(ROUTES.THIRD_PARTY_ACCOUNT_OPENING_PRIVACY_NOTICE);
  }, []);

  return null;
};

export default AccountOpeningPrivacyNotice;
